export default __webpack_public_path__ + "media/images/play-bg-75b8eefc13dcd4d9e1a2da0da5f7dd44.svg";